import './App.css';

function Doc() {
    return (
    <div className="Doc">
        <div className='flex-container'>
            <h1>Doc</h1>


        </div>
    </div>
  );
}

export default Doc;
